module.exports = __webpack_public_path__ + "img/body.8aa7c4a6.svg";